type Props = {
  label?: string;
  overlay?: boolean;
  /**
   * Conservé pour compat — le skeleton remplace barre / spinner
   * (même rendu quiet ou non).
   */
  quiet?: boolean;
};

function SkeletonBlock() {
  return (
    <div className="mail-body-skeleton" aria-hidden>
      <div className="mail-body-skeleton__meta">
        <div className="mail-body-skeleton__avatar mail-body-skeleton__shimmer" />
        <div className="mail-body-skeleton__lines">
          <div className="mail-body-skeleton__line mail-body-skeleton__line--md mail-body-skeleton__shimmer" />
          <div className="mail-body-skeleton__line mail-body-skeleton__line--sm mail-body-skeleton__shimmer" />
        </div>
      </div>
      <div className="mail-body-skeleton__divider" />
      <div className="mail-body-skeleton__body">
        <div className="mail-body-skeleton__line mail-body-skeleton__line--lg mail-body-skeleton__shimmer" />
        <div className="mail-body-skeleton__line mail-body-skeleton__line--full mail-body-skeleton__shimmer" />
        <div className="mail-body-skeleton__line mail-body-skeleton__line--full mail-body-skeleton__shimmer" />
        <div className="mail-body-skeleton__line mail-body-skeleton__line--md mail-body-skeleton__shimmer" />
        <div className="mail-body-skeleton__line mail-body-skeleton__line--lg mail-body-skeleton__shimmer" />
        <div className="mail-body-skeleton__line mail-body-skeleton__line--sm mail-body-skeleton__shimmer" />
      </div>
    </div>
  );
}

export function MessageBodyPreloader({
  label = "Ouverture du message…",
  overlay = false,
}: Props) {
  const content = (
    <div className="flex h-full min-h-[12rem] w-full flex-col" role="status" aria-label={label}>
      <SkeletonBlock />
    </div>
  );

  if (overlay) {
    return (
      <div className="mail-body-preloader-overlay" role="presentation">
        {content}
      </div>
    );
  }

  return (
    <div className="flex h-full min-h-[12rem] w-full bg-[var(--mail-surface)]">{content}</div>
  );
}
